var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRightRegular(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1367_17873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.5C8.36667 15.5 8.24067 15.448 8.14667 15.3533C7.952 15.1587 7.952 14.8413 8.14667 14.646L14.2933 8.49933H0.5C0.224 8.5 0 8.276 0 8C0 7.724 0.224 7.5 0.5 7.5H14.2927L8.146 1.35333C8.052 1.25933 8 1.13333 8 1C8 0.866667 8.052 0.740667 8.14667 0.646667C8.24067 0.552 8.36667 0.5 8.5 0.5C8.63333 0.5 8.75933 0.552 8.85333 0.646667L15.8533 7.64667C15.9 7.69333 15.9367 7.748 15.962 7.81C15.964 7.81533 15.9667 7.82133 15.9687 7.82733C15.9893 7.88133 16 7.94067 16 8C16 8.058 15.9893 8.116 15.9687 8.172C15.9673 8.176 15.966 8.17933 15.9647 8.18267C15.9367 8.252 15.8993 8.30733 15.8527 8.354L8.85333 15.3533C8.75933 15.448 8.63333 15.5 8.5 15.5Z",
    fill: "#0088A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1367_17873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightRegular);
export default __webpack_public_path__ + "static/media/icon-arrow-right-regular.b61e5ad9b8f3a13e08033f6627aee0ac.svg";
export { ForwardRef as ReactComponent };